export default __webpack_public_path__ + "static/powered-sites-a0dec48c1ccb350f26486809706f81ac.jpg";